// extracted by mini-css-extract-plugin
export var cancelButton = "_no-5";
export var content = "_no-3";
export var createButton = "_no-6";
export var drawerContainer = "_no-0";
export var footer = "_no-2";
export var header = "_no-1";
export var orderFormColumn = "_no-4";